export const escapeRegExpSearch = function escapeRegExpSearch(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
